<template lang="pug">
#app
	.page-container.md-layout-column
		md-toolbar.md-primary(md-fixed)
			md-button.md-icon-button(@click='showNavigation = true')
				md-icon menu
			span.md-title
				i.fas.fa-sun.fa-lg.mr1
				| Gambiarras e Algarzarras
		md-drawer(:md-active.sync='showNavigation' md-swipeable style="width: 275px;")
			md-toolbar.md-accent(md-elevation='0')
				span.md-title
					i.fas.fa-cogs.fa-2x.mr2
					| Enigma Stigma
			md-card
				md-card-media-cover(md-solid dark)
				md-card-media(md-ratio='5:4')
					img(src='./assets/images/enigma.jpg' style="filter: grayscale(1.0)")
			md-list(md-expand-single)
				md-list-item(md-expand :md-expanded.sync='expandNews')
					md-icon tv
					span.md-list-item-text Fake News
					md-list(slot='md-expand')
						md-list-item.md-inset(to='/about' @click='showNavigation = false') World
						md-list-item.md-inset(to='/about' @click='showNavigation = false') Europe
						md-list-item.md-inset South America
						md-list-item.md-inset North America
						md-list-item.md-inset Far East
						md-list-item.md-inset Eurasia
				md-list-item(md-expand)
					md-icon all_inclusive
					span.md-list-item-text Social Networks
					md-list(slot='md-expand')
						md-list-item.md-inset Facebook
						md-list-item.md-inset Twitter
						md-list-item.md-inset WhatsApp
						md-list-item.md-inset WeChat
						md-list-item.md-inset QZone
						md-list-item.md-inset Tumblr
						md-list-item.md-inset Instagram
						md-list-item.md-inset Baidu
						md-list-item.md-inset Viber
						md-list-item.md-inset Reddit

				md-list-item(md-expand)
					md-icon rowing
					span.md-list-item-text Infotainment
					md-list(slot='md-expand')
						md-list-item.md-inset Fox News
						md-list-item.md-inset Rede Globo
						md-list-item.md-inset Madih
						md-list-item.md-inset Ritha
						md-list-item.md-inset Khawal
						md-list-item.md-inset Muwashshahah
						md-list-item.md-inset Khamriyyah
				md-list-item(md-expand)
					md-icon autorenew
					span.md-list-item-text Gnosis Psychosis
					md-list(slot='md-expand')
						md-list-item.md-inset Signmund Freud
						md-list-item.md-inset Artemidorus
						md-list-item.md-inset ibn Khaldoun
						md-list-item.md-inset Ibn Sirin
						md-list-item.md-inset Al-Kindi
						md-list-item.md-inset Ann Faraday
						md-list-item.md-inset Calvin Hall


			//- md-list
			//- 	md-list-item
			//- 		md-icon move_to_inbox
			//- 		span.md-list-item-text Catharsis
			//- 	md-list-item
			//- 		md-icon send
			//- 		span.md-list-item-text Anagnorisis
			//- 	md-list-item
			//- 		md-icon delete
			//- 		span.md-list-item-text Antistrophe
			//- 	md-list-item
			//- 		md-icon error
			//- 		span.md-list-item-text Audience
			//- 	md-list-item
			//- 		md-icon all_inclusive
			//- 		span.md-list-item-text Hamartia
			//- 	md-list-item
			//- 		md-icon all_inclusive
			//- 		span.md-list-item-text Hubris
			//- 	md-list-item
			//- 		md-icon all_inclusive
			//- 		span.md-list-item-text Mimesis
			//- 	md-list-item
			//- 		md-icon all_inclusive
			//- 		span.md-list-item-text Pathos
			//- 	md-list-item
			//- 		md-icon all_inclusive
			//- 		span.md-list-item-text Peripateia
			//- 	md-list-item
			//- 		md-icon all_inclusive
			//- 		span.md-list-item-text Solioquy
		md-content
			router-view
</template>




<script>
  export default {
    name: 'Temporary',
    data: () => ({
      showNavigation: false,
      showSidepanel: false
    })
  }
</script>

<style lang="scss">

html, body, #app, md-drawer {
	height: 100%;
	margin: 0px;
}

.md-list {
	overflow: visible !important;
}

  .md-card {
    width: 320px;
    margin: 0px;
    display: inline-block;
    vertical-align: top;
  }

  .page-container {
    min-height: 100%;
    overflow: hidden;
    position: relative;
  }

  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }

  .md-content {
    padding: 16px;
  }

  .md-error {
	  background-color: #933333;
	  color: white;
  }
</style>